enum StatusBeneficiario {
  A = 'A',
  AL = 'AL',
  B = 'B',
  C = 'C',
  I = 'I',
  P = 'P',
  R = 'R',
  RO = 'RO',
  PENDENTE = '1',
  CONFIRMADA = '2',
  REJEITADA = '3',
}

export {
  StatusBeneficiario,
};
